import React, { useState } from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import List from "./List";
import ListEvent from "./ListEvent";
import Activated from "./Activated";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "@/redux/slices/userSlices";
import { getUserData } from "@/redux/slices/userSlices";
import { useSelector } from "react-redux";
import cloud_1 from "@/assets/cloud_1.png";
import cloud_2 from "@/assets/cloud_2.png";
import cloud_3 from "@/assets/cloud_3.png";
import cum_xe from "@/assets/cum_xe.png";

const data = [
  {
    label: "Kích Hoạt Phiếu",
    value: "activated",
    desc: <Activated />,
  },
  {
    label: "Phiếu kích hoạt",
    value: "list",
    desc: <List />,
  },
  {
    label: "Danh Sách Sự Kiện",
    value: "listevent",
    desc: <ListEvent />,
  },
];

const PhieuThayDau: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(getUserData);

  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    !searchParams.get("activatedTabs")
      ? "activated"
      : searchParams.get("activatedTabs")
  );

  const handelTabs = (value: string) => {
    const options = {
      search: `?activatedTabs=${value}`,
    };
    setActiveTab(value);
    navigate(options, { replace: true });
  };

  return (
    <>
      <div className="manager-container relative mb-36">
        {/* Cloud 1 - Top Right */}
        <div className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
          <img src={cloud_1} className="w-28" alt="Cloud 1" />
        </div>

        {/* Cloud 2 - Bottom Right */}
        <div className="absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2">
          <img src={cloud_2} className="w-28" alt="Cloud 2" />
        </div>

        {/* Cloud 3 - Bottom Left */}
        <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
          <img src={cloud_3} className="w-28" alt="Cloud 3" />
        </div>
        <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
          <img src={cum_xe} className="w-[90%]" alt="Cloud 3" />
        </div>
        <div className="manager-header py-4">
          <h1 className="text-xl md:text-2xl sm:text-2xl font-bold text-center">
            QUẢN LÝ PHIẾU THAY DẦU - {user ? user.name_shop : <></>}
          </h1>
          <Tabs value={activeTab}>
            <TabsHeader
              className="rounded-none border-b-2 border-red-50 bg-transparent p-4"
              indicatorProps={{
                className:
                  "bg-transparent border-b-4 border-red-500 shadow-none rounded-none mt-4",
              }}
            >
              {data.map(({ label, value }) => (
                <Tab
                  key={value}
                  value={value}
                  onClick={() => handelTabs(value)}
                  className={`${
                    activeTab === value
                      ? "text-red-500 font-bold"
                      : "text-red-100"
                  }`}
                >
                  <p className="text-xs sm:text-sm font-bold">{label}</p>
                </Tab>
              ))}
            </TabsHeader>
            <TabsBody>
              {data.map(({ value, desc }) => (
                <TabPanel key={value} value={value}>
                  {desc}
                </TabPanel>
              ))}
            </TabsBody>
          </Tabs>
        </div>
        <div className="flex gap-4 justify-end">
          <Link to={"/Manage/ChangePassword"} className="check-time-activated">
            Đổi mật khẩu
          </Link>
          <button className="logout" onClick={() => dispatch(logout())}>
            Đăng Xuất
          </button>
        </div>
      </div>
    </>
  );
};
export default PhieuThayDau;
